import { Tooltipster } from 'react-tooltipster';
import 'tooltipster/dist/css/tooltipster.bundle.css';

const ToolTip = ({
    content,
    side = 'top',
    children,
    theme = 'tooltipster-borderless',
    interactive = true
}) => {
    return (
        <Tooltipster
            className="sentiment-link"
            side={side}
            theme={theme}
            content={content}
            interactive={interactive}>
            {children}
        </Tooltipster>
    );
};
export default ToolTip;
